import { useTranslation } from "react-i18next";
import { Link, useNavigate } from 'react-router-dom';
import SelectTopK from './SelectTopK';
import ShowMetadataSelector from "./ShowMetaDataSelector";
import ShowDistance from "./ShowDistance";
import ShowDeepSearchHint from "./ShowDeepSearchHint";
// import SelectTopProductCategories from "./SelectTopProductCategories";
import ShowProductCategories from "./ShowProductCategories";
import DatabaseNamespace from "./DatabaseNamespace";


const Config = () => {
    const { t } = useTranslation()
    const navigate = useNavigate();

    return (
        <div className="card card-body m-2 p-2" style={{ width: "25em", position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)" }}>
            <SelectTopK></SelectTopK>
            <ShowProductCategories></ShowProductCategories>
            {/* <SelectTopProductCategories></SelectTopProductCategories> */}
            <ShowMetadataSelector></ShowMetadataSelector>
            <ShowDistance></ShowDistance>
            <ShowDeepSearchHint></ShowDeepSearchHint>
            <DatabaseNamespace></DatabaseNamespace>
            <button onClick={() => navigate(-1)} className='btn btn-secondary'>{t('Button.back')}</button>
        </div>
    )
}

export default Config